
// 封装 localStorage 的 setItem 方法
function setItem(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
}

// 封装 localStorage 的 getItem 方法
function getItem(key: string) {
    const value = localStorage.getItem(key);
    if (value === null) {
        return null;
    }
    try {
        return JSON.parse(value);
    } catch (e) {
        return value;
    }
}

const localStorageUtil = {
    setItem,
    getItem
};

export default localStorageUtil;